export const meta = Symbol("checkout.meta");
export const disable = "checkout.disableSubmitButton";
export const enable = "checkout.enableSubmitButton";
export const setFormsCompleted = "checkout.setFormsCompleted";
export const reset = "checkout.reset";
